var map = {
	"./image_doc_avatar_placeholder.png": [
		7246,
		246
	],
	"./image_error_graphic_illustration.png": [
		9985
	],
	"./image_lab_test_confirm.svg": [
		5886,
		886
	],
	"./image_login_graphic_illustration.svg": [
		9749,
		749
	],
	"./image_patient_avatar_placeholder.png": [
		4296,
		296
	],
	"./image_profile_cover_header_graphic.svg": [
		6065,
		65
	],
	"./image_profile_cover_header_mobile_graphic.svg": [
		7850,
		850
	],
	"./image_provider_completes_visits.svg": [
		5823,
		823
	],
	"./image_provider_on_desk.svg": [
		6436,
		436
	],
	"./image_river_avatar_placeholder.svg": [
		1710,
		710
	],
	"./image_river_logo.svg": [
		8399,
		399
	],
	"./image_river_patient_avatar_placeholder.svg": [
		1862,
		862
	],
	"./image_shine_home_plant_in_orange_pot.svg": [
		412,
		412
	],
	"./image_video_call_graphic_illustration.svg": [
		5204,
		204
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2358;
module.exports = webpackAsyncContext;